import type { Settings, SystemStatus } from './api'
export async function getConfig(): Promise<Settings> { return {} }
export async function saveConfig(_s: Settings) { return {} }
export async function getStatus(): Promise<SystemStatus> { return { running: false, workers_total: 0, workers_alive: 0, workers: [] } }
export async function startWorkers(): Promise<any> { return {} }
export async function stopWorkers(): Promise<any> { return {} }

// Заглушки для профайлер-only API, чтобы booster-сборка (VITE_PRODUCT=booster)
// собиралась: профайлер-компоненты импортируют эти символы, но в клиентском
// бандле профайлер выключен (HAS_PROFILER=false) и реально не вызывается.
// Должны соответствовать сигнатурам в api_profiler.ts.
export interface RemoteSettingsResult {
  ok: boolean
  id?: string
  raw?: Record<string, any>
  mapped?: Record<string, any>
  error?: string
  raw_preview?: string
}
export async function getProfilerRemoteSettings(_id: string): Promise<RemoteSettingsResult> {
  return { ok: false, error: 'profiler not available in this build' }
}
